module.exports = __webpack_public_path__ + "static/media/Mercy.6c89b2f7.jpg";